var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23,9c0-.58.34-1,.77-1H9.09V7c0-.57.34-1,.76-1s.76.47.76,1V8H25c.43,0,.77.46.77,1s-.34,1-.77,1H10.63V11c0,.58-.33,1-.76,1s-.78-.5-.78-1v-.94H7C6.53,10.05,6.23,9.59,6.23,9ZM25,21.93H22.89V21c0-.57-.35-1-.78-1s-.77.47-.77,1v.94H7.06c-.43,0-.77.46-.77,1s.34,1,.77,1H21.31V25c0,.56.34,1,.78,1s.75-.48.75-1V24H25c.42,0,.76-.48.76-1s-.34-1-.76-1Zm0-7H16.69V14c0-.58-.34-1-.75-1s-.76.46-.76,1V15H7c-.43,0-.77.47-.77,1s.34,1,.77,1h8.26V18c0,.58.32,1.05.75,1.05s.76-.47.76-1.05v-.83H25c.42,0,.76-.48.76-1S25.41,15,25,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarAdmin);
export default __webpack_public_path__ + "static/media/toolbar-admin.3d4c7ebf.svg";
export { ForwardRef as ReactComponent };